<template>
  <div class="content">
    <p class="ttile">
      秒杀<span>(说明:需要先创建秒杀活动，才可直接添加秒杀组件) </span>
    </p>
    <div class="set-content">
      <div class="set-item add-goods">
        <p class="title"><span>*</span>添加限时秒杀活动</p>
        <div class="table-box">
          <el-table
            :data="curComponent.activityInfos"
            border
            style="width: 100%;"
          >
            <el-table-column
              prop="name"
              align="center"
              label="活动名称"
              width="132"
            >
            </el-table-column>
            <el-table-column prop="name" align="center" label="场次" width="69">
              <template slot-scope="scope">
                <span v-if="scope.row.beginTime">{{
                  scope.row.beginTime.split(" ")[1].substr(0, 5)
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="address"
              align="center"
              label="状态"
              width="80"
            >
              <template slot-scope="scope">
                <p v-if="scope.row.activityStatus == 20">待开启</p>
                <p v-else-if="scope.row.activityStatus == 22">正在进行</p>
                <p v-else-if="scope.row.activityStatus == 3">已暂停</p>
                <p v-else-if="scope.row.activityStatus == 21">未开始</p>
                <p v-else-if="scope.row.activityStatus == 4">已结束</p>
                <p v-else-if="scope.row.activityStatus == 5">已过期</p>
              </template>
            </el-table-column>
            <el-table-column
              prop="address"
              align="center"
              label="操作"
              width="50"
            >
              <template>
                <i
                  @click="visibleSelectSeckillActivity = true"
                  style="font-size: 14px;color: #2F5FF5;cursor: pointer;"
                  class="el-icon-edit-outline"
                ></i>
              </template>
            </el-table-column>
          </el-table>
          <i @click="clear" class="el-icon-error"></i>
        </div>
        <el-button
          v-show="!curComponent.activityInfos.length"
          class="add-activity-btn"
          icon="el-icon-plus"
          @click="visibleSelectSeckillActivity = true"
          >添加秒杀活动</el-button
        >

        <template v-if="curComponent.goods.length">
          <p style="margin-top: 30px;" class="title"><span>*</span>商品</p>
          <GoodsControl v-model="curComponent.goods" @allRemoveDone="clear" />
        </template>
      </div>

      <div class="set-item">
        <p class="title">选择类型</p>
        <TypeGroup v-model="curComponent.type" :options="typeOptions" />
      </div>

      <div class="set-item basic-set">
        <p class="title">样式基础设置</p>
        <SpRadio
          v-model="curComponent.styleBasicSet.visibleGoodName"
          label="商品名称"
          :options="[
            { label: '显示', value: true },
            { label: '不显示', value: false }
          ]"
        />
        <SpRadio
          v-model="curComponent.styleBasicSet.visibleSpec"
          label="商品规格"
          :options="[
            { label: '显示', value: true },
            { label: '不显示', value: false }
          ]"
        />
        <SpRadio
          v-model="curComponent.styleBasicSet.visiblePrice"
          label="商品价格"
          :options="[
            { label: '显示', value: true },
            { label: '不显示', value: false }
          ]"
        />
        <SpRadio
          v-model="curComponent.styleBasicSet.visibleMarketPrice"
          label="商品原价"
          :options="[
            { label: '显示', value: true },
            { label: '不显示', value: false }
          ]"
        />
        <SpRadio
          v-model="curComponent.styleBasicSet.visibleCart"
          label="购物车"
          :options="[
            { label: '显示', value: true },
            { label: '不显示', value: false }
          ]"
        />
        <SpPickerColor
          v-model="curComponent.styleBasicSet.backgroundColor"
          :isGradient="true"
          label="背景颜色"
        />
        <SpPickerColor
          v-model="curComponent.styleBasicSet.goodsNameColor"
          defaultColor="#000000"
          label="商品名称颜色"
        />
        <SpPickerColor
          v-model="curComponent.styleBasicSet.goodsPriceColor"
          defaultColor="#fe2e57"
          label="商品价格颜色"
        />
        <SpSlider
          v-model="curComponent.styleBasicSet.goodsRadius"
          label="商品圆角值"
        />
        <SpSlider
          v-model="curComponent.styleBasicSet.pageMx"
          label="页面间距"
        />
        <SpSlider
          v-model="curComponent.styleBasicSet.goodsMx"
          label="商品间距"
        />
        <SpSlider
          v-model="curComponent.styleBasicSet.pageMb"
          label="页面底部间距"
        />
        <SpRadio
          v-model="curComponent.styleBasicSet.activityStyle"
          label="商品活动样式"
          :options="[
            { label: '样式一', value: 2 },
            { label: '样式二', value: 1 }
          ]"
        />
      </div>
    </div>

    <SelectSeckillActivity
      v-if="visibleSelectSeckillActivity"
      :isShowDialog="visibleSelectSeckillActivity"
      @closeShowDialog="params => (visibleSelectSeckillActivity = params)"
      @selected="selected"
    />
  </div>
</template>

<script>
import TypeGroup from "./components/TypeGroup";

import typeOptions from "./typeOptions";
import SpRadio from "../../../components/SpRadio";
import SpSlider from "../../../components/SpSlider";
import GoodsControl from "./components/GoodsControl";
import SpPickerColor from "../../../components/SpPickerColor";

import SelectSeckillActivity from "../../../components/SelectSeckillActivity.vue";
export default {
  components: {
    SpRadio,
    SpSlider,
    TypeGroup,
    GoodsControl,
    SpPickerColor,
    SelectSeckillActivity
  },
  inject: ["control"],
  data() {
    return {
      visibleSelectSeckillActivity: false,
      tableData: [],
      typeOptions: Object.freeze(typeOptions),
      curIndex: 1,
      maxGoodsCount: 100
    };
  },
  computed: {
    curComponent: {
      get() {
        return this.control.curComponent;
      },
      set(val) {
        this.control.curComponent = val;
      }
    }
  },
  methods: {
    clear() {
      this.curComponent.activityInfos = [];
      this.curComponent.goods = [];
    },

    selected({ activity, list }) {
      this.curComponent.activityInfos = [activity];
      this.curComponent.goods = list;
    }
  }
};
</script>

<style lang="less" scoped>
.content {
  .ttile {
    padding: 22px 24px 20px 24px;
    font-size: 16px;
    border-bottom: 1px solid #eee;
    font-weight: 500;
    span {
      font-size: 10px;
      color: #999999;
      padding-left: 10px;
    }
  }
  > .set-content {
    padding-top: 15px;
    padding: 20px 24px;
    > .set-item {
      > .title {
        font-size: 14px;
        font-weight: 500;
        margin-bottom: 12px;
        > span {
          color: red;
        }
      }
      > .dec {
        font-size: 12px;
        color: #999999;
        font-weight: 400;
        margin-bottom: 20px;
      }
      > .select-view {
        margin-top: 12px;
        > span {
          font-size: 12px;
          font-weight: 400;
        }
        > span:first-child {
          color: #999999;
        }
        > span:last-child {
          color: #333333;
          padding-left: 10px;
        }
      }
    }
    > .add-goods {
      margin-bottom: 30px;
      .table-box {
        position: relative;
        > i {
          position: absolute;
          font-size: 20px;
          color: #bbbbbb;
          right: -7px;
          top: -7px;
          background: #fff;
          border-radius: 50%;
          cursor: pointer;
          z-index: 999;
        }
      }
      /deep/ .el-table {
        .el-table__header-wrapper {
          .el-table__header {
            th.is-leaf {
              padding: 0;
              height: 32px;
              background: #f5f5f5;
            }
          }
        }
        .el-table__body-wrapper {
          .el-table__body {
            td {
              height: 40px;
              padding: 0;
            }
          }
        }
      }
      /deep/ .add-activity-btn {
        width: 332px;
        height: 30px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #2154f4;
        color: #2154f4;
        font-size: 12px;
        padding: 0;
        margin-top: 14px;
      }
    }

    > .basic-set {
      margin-top: 30px;
      > .radius-set-title {
        display: flex;
        align-items: center;
        background: #f7f8fa;
        border-radius: 4px;
        padding: 14px 12px 14px 16px;
        margin-bottom: 20px;
        > p {
          font-size: 12px;
          margin-right: 10px;
        }
        /deep/ .el-input {
          flex: 1;
          .el-input__inner {
            height: 30px;
            line-height: 30px;
            padding: 0 10px;
            font-size: 12px;
            color: #000000;
            &::placeholder {
              color: #999999;
            }
          }
        }
      }
      /deep/ .sp-radio {
        margin-bottom: 20px;
      }
      /deep/.picker-color {
        margin-bottom: 20px;
      }
      /deep/.slider-content {
        margin-bottom: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/custom-component/marketingComponents/Seckill/Attr.vue